/**
 * Copyright (C) 2021 Prosperia Salud, S.A. DE C.V. info@prosperia.health.
 * All rights reserved
 * DO NOT REDISTRIBUTE
 * The software MAY NOT be rewritten or refactored by any means. The code MAY
 * NOT be packaged and redistributed by any means without prior written
 * permission from the author.
 */
/// /// EXTERNAL /// ///
// mui //
import {
  Box, Typography,
  useMediaQuery,
} from '@mui/material';
// hook //
import useResponsive from 'hook/common/useResponsive';
// third party libraires //
import { useParams } from 'react-router-dom';
/// /// INTERNAL /// ///
// utils //
import cyberAttack from 'assets/img/cyber_attack.png';
import ErrorStatus from 'utils/constants';

const Error = ({ statusProps }) => {
  const { status } = useParams();
  const { downMd, theme } = useResponsive();
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const { grey } = theme.palette;

  const errorStatus = statusProps || +status;

  let customWidth = '652px';
  if (isSm) customWidth = '55%';
  else if (downMd) customWidth = '95%';

  const responsive = {
    typography: {
      title: {
        variant: 'h5',
        style: {
          color: grey[700],
          fontWeight: 800,
        },
      },
      subtitle: {
        variant: 'body1',
        style: {
          color: grey[800],
          textAlign: 'center',
        },
      },
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '27px',
      justifyContent: 'center',
      height: '100vh',
      alignItems: 'center',
    },
    titleContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      maxWidth: customWidth,
      gap: '16px',
    },
    image: {
      objectFit: 'contain',
      width: '100%',
      maxWidth: '299px',
      height: 'auto',
    },
  };

  let title = `Error ${errorStatus}`;
  let subtitle = (
    <Typography
      variant={responsive.typography.subtitle.variant}
      sx={responsive.typography.subtitle.style}
    >
      Lo sentimos, la página solicitada no ha sido encontrada.
    </Typography>
  );

  switch (errorStatus) {
  case ErrorStatus.NOT_AUTHORIZED:
    title = `Error ${errorStatus}`;
    subtitle = (
      <Typography
        variant={responsive.typography.subtitle.variant}
        sx={responsive.typography.subtitle.style}
      >
        Lo sentimos, el permiso ha sido denegado. Por favor contacta a nuestro equipo de
        soporte para obtener ayuda adicional.
      </Typography>
    );
    break;
  case ErrorStatus.FORBIDDEN_ERROR:
    title = `Error ${errorStatus}`;
    subtitle = (
      <Typography
        variant={responsive.typography.subtitle.variant}
        sx={responsive.typography.subtitle.style}
      >
        Lo sentimos, el permiso ha sido denegado. Por favor contacta a nuestro equipo de
        soporte para obtener ayuda adicional.
      </Typography>
    );
    break;
  default:
    break;
  }

  return (
    <Box sx={responsive.container}>
      <img src={cyberAttack} style={responsive.image} alt="error" />
      <Box sx={responsive.titleContainer}>
        <Typography
          variant={responsive.typography.title.variant}
          sx={responsive.typography.title.style}

        >
          {title}
        </Typography>
        {subtitle && subtitle}
      </Box>
    </Box>
  );
};

export default Error;
